import styled from 'styled-components';

export const Dialog = styled.div`
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Box = styled.div`
  background: #fdfdfd;
  padding: 32px;
  max-width: 360px;
  width: 100%;
  position: relative;
  border: 1px solid #ebebeb;
  box-shadow: 0px 0px 12px 6px rgba(0, 0, 0, 0.07);
  border-radius: 16px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  button {
    margin: 0 8px;
  }
`;

export const Header = styled.div`
  display: flex;
  margin-bottom: 17px;
  align-items: center;
  svg {
    fill: ${(props) => props.theme.colors['neutral-90']};
  }
`;

export const Title = styled.h2`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 18px;
  line-height: 21px;
  font-weight: 600;
  margin-left: 8px;
`;

export const Text = styled.p`
  margin-bottom: 24px;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  line-height: 21px;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 16px;
  top: 16px;
  svg {
    fill: #abacaf;
    width: 16.31px;
  }
`;
